import { saveAs } from 'file-saver';
import xlsx from 'xlsx';
import ShpGenerate from "./ShpGenerate.js";

import { GeoJSON, WKT } from "ol/format";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import split from "lodash/split";
import trim from "lodash/trim";
import zipObject from "lodash/zipObject";
import isArray from "lodash/isArray";
import join from "lodash/join";
import uniq from "lodash/uniq";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import each from "lodash/each";
import flatten from "lodash/flatten";
import sortBy from "lodash/sortBy";
mixin(_, {
  chain,
  split,
  trim,
  map,
  zipObject,
  filter,
  isArray,
  join,
  uniq,
  keyBy,
  mapValues,
  each,
  flatten,
  sortBy
});
_.value = value;
_.prototype.value = value;

function csvToArray(csvString) {
  return _(csvString).split('\r\n').map(row => _(row).split(';;').map((cell) => _.trim(cell, '"')).value()).value();
}
function geojsonToArray(features, formater) {
  let header = _(features).map(feature => Object.keys(feature.getProperties())).flatten().uniq().sortBy().value();
  _.each(['geometry', 'id'], col => {
    const idx = header.indexOf(col);
    if (idx > -1) {
      header.splice(idx, 1);
    }
  });
  header.unshift('geometry');
  header.unshift('id');
  const headerMap = _(header).map((key, value) => ({
      key,
      value
    })).keyBy('key').mapValues('value').value();


  const data = _.map(features, feature => {
    const row = [];
    row.push(feature.getId());
    row.push(formater.writeGeometryText(feature.getGeometry()));
    _.each(Object.keys(feature.getProperties()), attr => {
      if (attr !== 'geometry') {
        let value = feature.get(attr);
        try {
          if (typeof value !== 'string') {
            value = JSON.stringify(value);
          }
        } catch (ex) {
          console.log(feature, attr, value);
          value = `${value}`;
        }
        row[headerMap[attr]] = value;
      }
    });
    return row;
  });

  return [header, ...data];
}
function arrayToCSV(data) {
  return _(data).map(row => _(row).map(cell => `"${cell}"`).join(',').value()).join('\r\n').value();
}

const new_ws_name = "export-aquagis";

export default {
  agGrid(columnDefs, gridOptions, type = 'csv') {
    const params = {
      processCellCallback(cell) {
        let value = `${cell.value}`;
        if ('[object Object]' === value) {
          value = JSON.stringify(cell.value);
        }
        return value;
      },
      fileName: `${new_ws_name}.${type}`
    };
    params.columnKeys = _(columnDefs)
            .filter(column => column.headerName !== "")
            .map(column => column.field)
            .value();

    if (type === 'csv') {
      gridOptions.api.exportDataAsCsv(params);
    } else if (type === 'xlsx') {
      params.columnSeparator = ';;';
      const worksheet = xlsx.utils.aoa_to_sheet(csvToArray(gridOptions.api.getDataAsCsv(params)));
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, new_ws_name);
      xlsx.writeFile(workbook, `${new_ws_name}.${type}`);
  }
  },
  
  mapFields(feature, fields) {
    if (fields) {
      _.each(fields, field => {
        let value = feature.get(field.name) || "";
        feature.unset(field.name, true);
        feature.set(field.display_name, value, true);
      });
    }
    return feature;
  },
  attrTable(filtredItems, options = {}, type = 'csv') {
    if (type === 'csv') {
      const features = _.map(filtredItems, (feature) => this.mapFields(feature.__value.clone(), options.fields));
      const formatWKT = new WKT({
        dataProjection: options.srid,
        featureProjection: options.projection
      });
      let result = geojsonToArray(features, formatWKT);
      result = arrayToCSV(result);

      const blob = new Blob([result], {type: "text/plain;charset=utf-8"});
      saveAs(blob, `${new_ws_name}.${type}`);
    } else if (type === 'xlsx') {
      const features = _.map(filtredItems, (feature) => this.mapFields(feature.__value.clone(), options.fields));
      const formatWKT = new WKT({
        dataProjection: options.srid,
        featureProjection: options.projection
      });
      const result = geojsonToArray(features, formatWKT);

      const worksheet = xlsx.utils.aoa_to_sheet(result);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, new_ws_name);
      xlsx.writeFile(workbook, `${new_ws_name}.${type}`);
    } else if (type === 'shp') {
      const formatGeoJSON = new GeoJSON({
        dataProjection: options.srid,
        featureProjection: options.projection
      });

      const features = _.map(filtredItems, (feature) => this.mapFields(feature.__value.clone(), options.fields));
      const geojson = formatGeoJSON.writeFeaturesObject(features, {
        dataProjection: options.srid,
        featureProjection: options.projection
      });
      
      ShpGenerate(geojson, {
        folder: new_ws_name,
        srid : options.srid
      });
    } else if (type === 'geojson') {
      const formatGeoJSON = new GeoJSON({
        dataProjection: options.srid,
        featureProjection: options.projection
      });

      const features = _.map(filtredItems, (feature) => this.mapFields(feature.__value.clone(), options.fields));
      const geojson = formatGeoJSON.writeFeaturesObject(features, {
        dataProjection: options.srid,
        featureProjection: options.projection
      });

      const blob = new Blob([JSON.stringify(geojson)], {type: "application/json;charset=utf-8"});
      saveAs(blob, `${new_ws_name}.${type}`);
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/exportTableData.js